import type { VoiceComposerLabels } from '@orborix/voice-composer';

/**
 * Strings del composer compartido (`@orborix/voice-composer`) en el tono de
 * speak (rioplatense, voseo; el coach es "Coach", como en el resto de la
 * pantalla). El package NO trae textos default (fail-fast) — este objeto es el
 * diccionario resuelto que consumen ambas shells de /conversation.
 */
export const COMPOSER_LABELS: VoiceComposerLabels = {
  hold: 'Mantené para hablar',
  releaseToSend: 'Soltá para enviar',
  releaseToCancel: 'Soltá para cancelar',
  slide: '‹ cancelar',
  send: 'Enviar',
  discard: 'Descartar audio',
  pause: 'Pausar grabación',
  resume: 'Seguir grabando',
  listenToMe: 'Escuchar lo grabado',
  pauseListening: 'Pausar la escucha',
  // Aviso flotante del composer: el envío murió sin transcript.
  nothingHeard: 'No se escuchó tu voz — tocá el mic y probá de nuevo',
  noSound: 'No nos llega sonido. ¿Otra app usa el micrófono?',
  // Aviso del panel cuando el WS se cae con el hold en curso: ese audio quedó
  // sólo en el teléfono, no le llegó al coach.
  connectionLost: 'Se cortó la conexión',
  audioNotSent: 'Este audio no se envió. Descartalo y grabalo de nuevo.',
  // Modo charla a manos libres (mic abierto entre turnos, cierre por VAD).
  freeChat: 'Modo charla',
  listening: 'Te escucho…',
  // «Te escucho» visual (#518): el turno ya se cerró, antes de «pensando».
  heard: 'Te escuché',
  thinking: 'Coach está pensando…',
  speaking: 'Coach está hablando…',
  micMuted: 'Mic silenciado',
  mute: 'Silenciar mic',
  unmute: 'Activar mic',
  exitFreeChat: 'Salir del modo charla',
};

/** Placeholder del campo (diseño aprobado: invita a ambas entradas). */
export const COMPOSER_PLACEHOLDER = 'Escribí o mantené el mic';

/** Placeholder sin mic usable (`micHidden`): el composer queda sólo-texto, así
 *  que invitar al mic sería señalar un botón que no está. */
export const COMPOSER_PLACEHOLDER_TEXT_ONLY = 'Escribí tu mensaje';

/** Placeholder terminal: la sesión cerró server-side y el composer queda
 *  inhabilitado (paridad con el viejo TextCompose — el envío sería un no-op
 *  silencioso, así que se inhabilita visiblemente). */
export const COMPOSER_PLACEHOLDER_ENDED = 'La conversación terminó';
